// extracted by mini-css-extract-plugin
module.exports = {"root":"qBVY_FqI","trigger":"K2xstAEJ"};